import React from 'react';
import PropTypes from 'prop-types';
import {Col, Row} from 'react-flexa'
import {withStyles} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Image from '../../components/Image'
import Typography from '../../components/Typography'
import {imageRoot} from '../../../env.config'

const styles = theme => ({
  container: {
    background: `url(${imageRoot}/homepage/pattern2.png) #fefefe`,
    padding: '80px 20px',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '4rem 2rem'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '2rem 1rem'
    },
  },
  content: {
    padding: '4rem 5rem',
    backgroundColor: 'white',
    boxShadow: '2px 0 24px 0 #eee',
    [theme.breakpoints.down('sm')]: {
      padding: '4rem 2rem'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '2rem 1rem'
    },
  },
});


class NamedBrands extends React.Component {
  state = {
    buttonHover: false,
  };

  toggleButtonHover = (buttonHover) => e => {
    this.setState({buttonHover});
  };

  render() {
    const { classes, otherClasses } = this.props;
    const { buttonHover } = this.state;
    return (
      <div className={classes.container}>
        <Row gutter={0} style={{maxWidth: 1343}}>
          <Col xs={12} sm={12} md={6} gutter={0} style={{display: 'flex', alignItems: 'center'}}>
            <Image src="/homepage/kitchen.jpg" width='100%'/>
          </Col>
          <Col xs={12} sm={12} md={6} gutter={0}>
            <Row gutter={0}>
              <Col xs={12} sm={10} className={classes.content} gutter={0}>
                <Typography variant='subtitle2' color='primary'>PERKS OF BEING A MEMBER</Typography>
                <Typography bold={true} variant='h3'>Top Name Brands<br/>at Wholesale Prices.</Typography>
                <Typography variant='body1'>DirectBuy is the #1 Membership Club for home furniture in the US & Canada
                  for everything in and around your home. Since 1971, we've helped our members save over 20
                  billion dollars to build the home they have always dreamed of at a price never imagined.
                </Typography>
                <Button
                  className={otherClasses.button}
                  component='a'
                  href='/v2/membership-pricing/'
                  color='primary'
                  size='large'
                  fullWidth={true}
                  variant={buttonHover ? 'contained' : 'outlined'}
                  onMouseOver={this.toggleButtonHover(true)}
                  onMouseLeave={this.toggleButtonHover(false)}
                >
                  Become a Member Today!
                </Button>
              </Col>
              <Col xs={0} sm={1} gutter={0}>
                <Image src="/homepage/red-arrow.png"/>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

NamedBrands.propTypes = {
  classes: PropTypes.object.isRequired,
  otherClasses: PropTypes.object.isRequired,
};

export default withStyles(styles)(NamedBrands)
